import Footer from 'layout/footer';
import Header from 'layout/header';
import React, { Fragment, useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form, InputGroup, ListGroup, Button } from 'react-bootstrap';
import { BsCheckCircleFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { loadFromLocalStorage } from 'utils/LocalStorageUtils';
import { isEmpty } from 'utils/utils';

function OrderConfirmation({ handleBack, orderCompleateData }) {
  const navigate = useNavigate();
  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])

  async function handleClosePage() {
    navigate('/managetemplate')
    handleBack()
  }
  const handleDownloadPdf = async (recipt) => {
    if (!isEmpty(recipt)) {
      const response = await fetch(recipt);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'output.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  };
  return (
    <Fragment>
      <br /> <br />
      <Container>
        <div>
          <Card className="p-4" style={{ border: '1px solid #ddd', borderRadius: '12px' }}>
            {/* Header Section */}
            <Card.Header className="text-left" style={{ backgroundColor: 'white', borderBottom: 'none' }}>
              <h3 className="text-success">
                <BsCheckCircleFill className="me-3" />
                {languageData?.yourOrderHasBeenConfirmed}
              </h3> <br />
              <p>{languageData?.thankYouForChoosing}!</p>
              <p>{languageData?.weAreThrilledToHaveYouOnBoard}</p>
            </Card.Header>

            {/* Order Summary Section */}
            <Card.Body>
              <Row>
                {/* Left Column - Order Summary */}
                <Col md={6}>
                  <h5>{languageData?.orderSummary}:</h5>
                  <p><strong>Name:</strong> {orderCompleateData?.billing_details?.name}</p>
                  <p><strong>Phone:</strong> {orderCompleateData?.billing_details?.mobile}</p>
                  <p><strong>Email:</strong> {orderCompleateData?.billing_details?.email}</p>

                  <h5 className="mt-4">{languageData?.planDetails}:</h5>
                  <ul>
                    <li>Free SSL</li>
                    <li>Premium Domain</li>
                    <li>Free Hosting</li>
                    {Boolean(orderCompleateData?.aimarketing_status) &&
                      <li>AI Marketing</li>
                    }
                    <li>Instant Contact Notifications</li>
                    <li>Internationally Acclaimed Templates</li>
                    <li>24/7 Support</li>
                  </ul>

                  <p><strong>Plan Validity:</strong> 1 year from the date of Publish</p>
                </Col>

                {/* Right Column - Price Summary */}
                <Col md={6}>
                  <h5>{languageData?.summary}:</h5>
                  <p> <strong>Base Price (Yearly):</strong> ₹10 x 365 days </p>
                  <p>
                    <strong>Premium Domain:</strong> ₹{orderCompleateData?.domain_price}
                  </p>
                  <p>
                    <strong>Add on:</strong> AI Marketing {Boolean(orderCompleateData?.aimarketing_status) ? '₹5 x 365 days' : '-'}
                  </p>
                  <hr />
                  <h5>Total: ₹{orderCompleateData?.total_amount}</h5>

                  <p className="text-muted mt-3" style={{ fontSize: '0.9rem' }}>
                    {languageData?.noteItWillTakeDaysForYourWebsiteToGetPublished}
                  </p>
                </Col>
              </Row>
            </Card.Body>

            {/* Footer Section */}
            <Card.Footer className="text-end" style={{ backgroundColor: 'white', borderTop: 'none' }}>
              <small>Order no #{!isEmpty(orderCompleateData?._id) && orderCompleateData?._id.slice(-4)}</small>
            </Card.Footer>
          </Card>
        </div> <br />
        <Button
          style={{ borderRadius: 50, width: 'fit-content', fontSize: 14, background: '#ff966a', color: '#000', fontWeight: 500 }}
          size='lg' onClick={() => handleClosePage(0)}>
          {languageData?.manageYourTemplates}
        </Button>
        <Button
          style={{ marginLeft: 20, borderRadius: 50, width: 'fit-content', fontSize: 14, background: '#ff966a', color: '#000', fontWeight: 500 }}
          size='lg' onClick={() => handleDownloadPdf(orderCompleateData?.invoice_link)}>
          {languageData?.downloadReceipt}
        </Button>
      </Container>
    </Fragment>
  );
}

export default OrderConfirmation;
